"use strict"; // @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

var migration = require("./migration");

exports.migration = migration;

var wizard = require("./wizard");

exports.wizard = wizard;